/**
 * Der Zugriffstoken der laufenden Sitzung — ausschließlich im Speicher.
 *
 * **Nicht in `localStorage`:** von dort kann ihn jedes eingeschleuste Skript
 * lesen. Er muss aber von JavaScript lesbar sein, weil er in jeden
 * `Authorization`-Kopf gehört — also bleibt nur der Speicher.
 *
 * Der **Auffrischungstoken steht hier nicht mehr.** Er liegt seit ADR 0015 im
 * `HttpOnly`-Cookie `hm_refresh` und kommt in JavaScript gar nicht erst an: Der
 * Browser schickt ihn von sich aus an `/api/v1/auth`, und der Server antwortet
 * mit einem neuen. Damit übersteht die Sitzung ein Neuladen, ohne dass der
 * langlebige Token irgendwo lesbar herumliegt — das war die offene Frage OQ-018.
 *
 * Dieses Modul importiert nichts. So können sowohl der API-Client als auch die
 * Sitzungsverwaltung darauf zugreifen, ohne einander zu kennen.
 */
export interface StoredSession {
  readonly accessToken: string;
  /** Zeitpunkt, ab dem der Zugriffstoken nicht mehr gilt. */
  readonly expiresAt: number;
  readonly accountId: string;
}

let session: StoredSession | null = null;

export function readSession(): StoredSession | null {
  return session;
}

export function writeSession(next: StoredSession | null): void {
  session = next;
}

export function accessToken(): string | null {
  return session?.accessToken ?? null;
}

export function accountId(): string | null {
  return session?.accountId ?? null;
}
